import React from 'react';

const SkeletonBox = ({ className = "", width = "w-full", height = "h-4" }) => (
  <div className={`${width} ${height} bg-gray-200 rounded animate-pulse ${className}`} />
);

const SkeletonPulse = ({ className = "", children }) => (
  <div className={`animate-pulse ${className}`}>
    {children}
  </div>
);

// Skeleton for a single chart area
const ChartSkeleton = ({ height = "h-80" }) => (
  <SkeletonPulse>
    <div className="flex flex-col space-y-3">
      {/* Chart area */}
      <SkeletonBox width="w-full" height={height} className="rounded-lg" />
      {/* Chart label */}
      <SkeletonBox width="w-20" height="h-3" />
    </div>
  </SkeletonPulse>
);

// Skeleton for detailed chart section (2x2 grid)
const DetailedChartsSkeleton = () => (
  <div className="grid grid-cols-2 gap-4 mb-4">
    {/* Cost to Gavi section */}
    <div className="bg-white p-4 border shadow-sm rounded-[var(--border-corner-radius-rounding-03)]">
      <SkeletonPulse>
        <SkeletonBox width="w-32" height="h-5" className="mx-auto mb-3" />
        <div className="grid grid-cols-2 gap-2">
          <ChartSkeleton height="h-72" />
          <ChartSkeleton height="h-72" />
        </div>
      </SkeletonPulse>
    </div>
    
    {/* Cost to Country section */}
    <div className="bg-white p-4 border shadow-sm rounded-[var(--border-corner-radius-rounding-03)]">
      <SkeletonPulse>
        <SkeletonBox width="w-36" height="h-5" className="mx-auto mb-3" />
        <div className="grid grid-cols-2 gap-2">
          <ChartSkeleton height="h-72" />
          <ChartSkeleton height="h-72" />
        </div>
      </SkeletonPulse>
    </div>
  </div>
);

// Skeleton for simplified charts section (1x2 grid)
const SimplifiedChartsSkeleton = () => (
  <div className="grid grid-cols-2 gap-4 mb-4">
    <ChartSkeleton height="h-64" />
    <ChartSkeleton height="h-64" />
  </div>
);

// Skeleton for data summary section
const DataSummarySkeleton = () => (
  <div className="mt-4 p-4 bg-gray-50 rounded-[var(--border-corner-radius-rounding-03)]">
    <SkeletonPulse>
      <div className="flex justify-between items-center mb-2">
        <SkeletonBox width="w-28" height="h-5" />
        <SkeletonBox width="w-24" height="h-8" className="rounded" />
      </div>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="space-y-1">
          <SkeletonBox width="w-32" height="h-4" />
          <SkeletonBox width="w-48" height="h-4" />
        </div>
        <div className="space-y-1">
          <SkeletonBox width="w-36" height="h-4" />
          <SkeletonBox width="w-44" height="h-4" />
        </div>
      </div>
    </SkeletonPulse>
  </div>
);

// Complete VPOPOutputs skeleton
const VPOPOutputsSkeleton = () => (
  <div>
    <SkeletonPulse>
      {/* Title */}
      <SkeletonBox width="w-32" height="h-6" className="mb-4" />
      
      {/* Optional budget message */}
      <SkeletonBox width="w-96" height="h-4" className="mb-3" />
    </SkeletonPulse>
    
    {/* Detailed charts section */}
    <DetailedChartsSkeleton />
    
    {/* Simplified charts section */}
    <SimplifiedChartsSkeleton />
    
    {/* Data summary section */}
    <DataSummarySkeleton />
  </div>
);

export default VPOPOutputsSkeleton;
export { ChartSkeleton, DetailedChartsSkeleton, SimplifiedChartsSkeleton, DataSummarySkeleton };